import { useEffect } from 'react';

export function usePolling(callback, intervalMs, deps = [], options = { immediate: false }) {
  useEffect(() => {
    let cancelled = false;

    if (options?.immediate) {
      Promise.resolve().then(() => {
        if (!cancelled) callback();
      });
    }

    const id = setInterval(() => {
      callback();
    }, intervalMs);

    return () => {
      cancelled = true;
      clearInterval(id);
    };
    // callback-ot szándékosan nem tesszük függőségnek; stabil deps-t adj.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervalMs, ...deps]);
}
